import axios from "axios";

export const loginAuthentication = async (credentials) => {
  const data = JSON.stringify({
    email: credentials.email,
    password: credentials.password,
  });
  const config = {
    method: "POST",
    url: "http://unioninformatica.org:4000/api/v1/boletaDigital/loginAuthentication",
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  try {
    const response = axios(config);
    return await response;
  } catch (error) {
    const { response } = error;
    return await response;
  }
};
